import { render, staticRenderFns } from "./SelectionTable.vue?vue&type=template&id=32547fba&scoped=true&"
import script from "./SelectionTable.vue?vue&type=script&lang=ts&"
export * from "./SelectionTable.vue?vue&type=script&lang=ts&"
import style0 from "./SelectionTable.vue?vue&type=style&index=0&id=32547fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32547fba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VImg,VRow,VSpacer})
